<template>
  <div>
    <div class="card">
      <img v-bind:class="{'card__image--vehicle' : !this.isFallback, 'card__image--fallback' : this.isFallback}" :src="imageUrl">
        <div class="card__header">{{vehicleNameHeader}}</div>
        <div class="card__subheader">{{vehicleNameSubheader}}</div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Provide, Vue, Watch
} from 'vue-property-decorator';
import {
  State, Getter, Action, Mutation, namespace
} from 'vuex-class';
import VehicleLevel from '@/enums/VehicleLevel';
import IDerivative from '../../models/vehicle/interfaces/derivative.d';
import IRange from '../../models/vehicle/interfaces/range.d';

const VehicleModule = namespace('vehicleModule');
const InitialSettingsModule = namespace('initialSettingsModule');
const SearchQueryModule = namespace('searchQueryModule');

@Component
export default class VehicleConfirmationComponent extends Vue {
  @VehicleModule.Getter public currentDerivative!: IDerivative;

  @VehicleModule.Getter public currentRange!: IRange;

  @InitialSettingsModule.Getter public vehicleTypeName;

  @SearchQueryModule.Getter public searchQuery;

  public isFallback: boolean = false;

  public get vehicleNameHeader(): string {
    if (this.currentDerivative !== null) {
      return `${this.currentDerivative.manufacturerName} ${this.currentDerivative.rangeName} ${this.currentDerivative.bodystyles[0]}`;
    }

    if (this.currentRange !== null) {
      return `${this.currentRange.manufacturerName} ${this.currentRange.rangeName}`;
    }

    return '';
  }

  public get vehicleNameSubheader(): string {
    if (this.currentDerivative == null) {
      return '';
    }

    return this.searchQuery.vehicleLevel === VehicleLevel.Trim ? this.currentDerivative.trimName : this.currentDerivative.derivativeName;
  }

  public get vehicleType(): string {
    return this.vehicleTypeName === 'car' ? 'car' : 'van';
  }

  public get imageUrl(): string {
    if (this.currentDerivative !== null) {
      if (this.currentDerivative.images.basic.length === 0) {
        this.isFallback = true;
        return this.manufacturerLogo;
      }
      return `//image.uk-tla.com/api/v1/image/vehicle/${this.vehicleType}/${this.currentDerivative.manufacturerNameSlug}/${this.currentDerivative.rangeNameSlug}/basic/${this.currentDerivative.images.basic[0].imageId}/260`;
    }

    if (this.currentRange !== null) {
      if (this.currentRange.images.basic.length === 0) {
        this.isFallback = true;
        return this.manufacturerLogo;
      }
      return `//image.uk-tla.com/api/v1/image/vehicle/${this.vehicleType}/${this.currentRange.manufacturerNameSlug}/${this.currentRange.rangeNameSlug}/basic/${this.currentRange.images.basic[0].imageId}/260`;
    }

    return '';
  }

  public get manufacturerLogo(): string {
    if (this.currentRange !== null) {
      return `//image.uk-tla.com/api/v1/image/vehicle/${this.vehicleType}/${this.currentRange.manufacturerNameSlug}/logo/260`;
    }

    return '';
  }
}
</script>
